const screenBreakpoints = {
  xs: '360px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1200px',
  '2xl': '1440px',
  '3xl': '1600px',
  '4xl': '1920px',
};

module.exports = { screenBreakpoints };
